import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-screen"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full flex flex-col justify-center items-center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-4xl extrabold text-center" }, "This Lesson is Locked!", -1)
const _hoisted_5 = { class: "text-xl text-center lg:text-left py-4 extrabold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UISpinner = _resolveComponent("UISpinner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isPortalNavbar ? 'pt-14' : '')
  }, [
    (_ctx.fetching || _ctx.fetchingPost || _ctx.fetchingDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_UISpinner, { size: "large" })
        ]))
      : (_ctx.isCategoryLocked || _ctx.parentCategoryLocked || _ctx.isActivePostLocked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "h-20 py-4",
              src: _ctx.lockIcon,
              alt: "Lock Category"
            }, null, 8, _hoisted_3),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, " To gain access to this " + _toDisplayString(_ctx.lockedOverlayContentText) + " please complete. ", 1),
            (_ctx.lockedPost)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.showLockedButton && _ctx.lockedPost && _ctx.lockedPost.title)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectToPost(_ctx.lockedPost.categoryId, _ctx.lockedPost.id))),
                        class: "my-4 rounded text-white lg:px-8 lg:py-4 md:px-6 md:py-3 px-4 py-2 bg-gray-800 cursor-pointer"
                      }, _toDisplayString(`Post Name` && `Post: ${_ctx.lockedPost.title}`), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.lockedCategory)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.showLockedButton && _ctx.lockedCategory && _ctx.lockedCategory.title)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToPost(_ctx.lockedCategory.id))),
                        class: "my-4 rounded text-white lg:px-8 lg:py-4 md:px-6 md:py-3 px-4 py-2 bg-gray-800 cursor-pointer"
                      }, _toDisplayString(`Category Name` && `Category: ${_ctx.lockedCategory.title}`), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showLockedButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_UISpinner, { size: "small" })
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["max-w-6xl w-full mx-auto md:px-0", [
        _ctx.newMobileScreens ? '' : 'my-4 px-4',
        _ctx.selectedTheme !== 'Neue' && !_ctx.newMobileScreens
          ? 'max-w-6xl my-4 px-4'
          : '',
      ]])
          }, [
            (_ctx.routeName.includes('post-overview'))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(`${_ctx.selectedTheme}LessonTheme`), {
                  key: 0,
                  product: _ctx.product,
                  instructor: _ctx.instructor,
                  activePost: _ctx.activePost,
                  category: _ctx.category,
                  videoOptions: _ctx.videoOptions,
                  videoCompletePercentage: _ctx.videoCompletePercentage,
                  nextPost: _ctx.nextPost,
                  playlist: _ctx.playlist,
                  lessonButton: _ctx.lessonButton,
                  isAdmin: _ctx.isAdmin,
                  categoryTree: _ctx.categoryTree,
                  nextLesson: _ctx.nextLesson,
                  disableActions: _ctx.disableActions,
                  fetchingPost: _ctx.fetchingPost,
                  nextCategoryId: _ctx.nextCategoryId,
                  completedPostIds: _ctx.completedPostIds,
                  markCompletedBtnCss: _ctx.markCompletedBtnCss,
                  postMarkedAsCompleted: _ctx.postMarkedAsCompleted,
                  postCompletionButtonText: _ctx.postCompletionButtonText,
                  disablePostCompletionButton: _ctx.disablePostCompletionButton,
                  fetchingPostCompletionStatus: _ctx.fetchingPostCompletionStatus,
                  totalPosts: _ctx.totalPosts,
                  completedPosts: _ctx.completedPosts,
                  onTogglePostCompletion: _ctx.togglePostCompletion,
                  onUpdateBackData: _ctx.updateBackData,
                  onStoreVideoProgress: _ctx.storeVideoProgress,
                  onUpdateVideoTime: _ctx.updateVideoTime,
                  onUpdateVideoPlay: _ctx.updateVideoPlay,
                  onStoreAudioProgress: _ctx.storeAudioProgress,
                  onUpdateAudioTime: _ctx.updateAudioTime,
                  onUpdateAudioPlay: _ctx.updateAudioPlay,
                  hasProductAccess: _ctx.hasProductAccess
                }, null, 40, ["product", "instructor", "activePost", "category", "videoOptions", "videoCompletePercentage", "nextPost", "playlist", "lessonButton", "isAdmin", "categoryTree", "nextLesson", "disableActions", "fetchingPost", "nextCategoryId", "completedPostIds", "markCompletedBtnCss", "postMarkedAsCompleted", "postCompletionButtonText", "disablePostCompletionButton", "fetchingPostCompletionStatus", "totalPosts", "completedPosts", "onTogglePostCompletion", "onUpdateBackData", "onStoreVideoProgress", "onUpdateVideoTime", "onUpdateVideoPlay", "onStoreAudioProgress", "onUpdateAudioTime", "onUpdateAudioPlay", "hasProductAccess"]))
              : (_openBlock(), _createBlock(_component_router_view, {
                  key: 1,
                  product: _ctx.product,
                  activePost: _ctx.activePost,
                  category: _ctx.category,
                  categoryTree: _ctx.categoryTree,
                  nextPost: _ctx.nextPost,
                  playlist: _ctx.playlist,
                  instructor: _ctx.instructor,
                  fetchingPostCompletionStatus: _ctx.fetchingPostCompletionStatus,
                  disablePostCompletionButton: _ctx.disablePostCompletionButton,
                  isAdmin: _ctx.isAdmin,
                  isUngradedAssignment: _ctx.isUngradedAssignment,
                  markCompletedBtnCss: _ctx.markCompletedBtnCss,
                  postCompletionButtonText: _ctx.postCompletionButtonText,
                  onUpdateBackData: _ctx.updateBackData,
                  onTogglePostCompletion: _ctx.togglePostCompletion
                }, null, 8, ["product", "activePost", "category", "categoryTree", "nextPost", "playlist", "instructor", "fetchingPostCompletionStatus", "disablePostCompletionButton", "isAdmin", "isUngradedAssignment", "markCompletedBtnCss", "postCompletionButtonText", "onUpdateBackData", "onTogglePostCompletion"]))
          ], 2))
  ], 2))
}